import React from 'react';
import { useSelector } from 'react-redux';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

function MoreInfo({setEditInfo}) {
    const cellAttuale = useSelector((user) => user.user.info.customer_mobile)
    const emailAttuale = useSelector((user) => user.user.info.user_email)
    return (
        <div className="moreInfo">
            <div className="inputPlace">
                <p className="label">Email</p>
                <p className="placeholder">{emailAttuale.toLowerCase()}</p>
            </div>
            <div className="inputPlace">
                <p className="label">Telefono</p>
                <p className="placeholder">{cellAttuale}</p>
            </div>
            <div className="inputPlace password">
                <p className="label">Password</p>
                <p className="placeholder password">pietro@revoluce.it</p>
            </div>
            <div className="edit">
                <button onClick={() => setEditInfo(true)}><ModeEditIcon /> Modifica i dati</button>
            </div>
        </div>
    );
}

export default MoreInfo;
